export const IClose = () => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1.00098 1L21.001 21" stroke="#A5A5A5" strokeWidth="2" strokeLinecap="round" />
            <path d="M1.00098 21L21.001 1" stroke="#A5A5A5" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};
